import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import theme from '~/design'
import { onAuthStateChanged, User } from 'firebase/auth'
import { auth } from '~/utils/client/auth'
import { bypassAuth } from '~/utils/shared/platform'
import { faChevronLeft, faBars } from '@fortawesome/free-solid-svg-icons'

import Loader from '~/prix/react/components/loader'
import useAPI from '~/prix/react/hooks/api'
import { ButtonVariants } from '../buttonVariants'
import ManagementSidebar from './managementSidebar'

const Layout = styled.div`
  display: flex;
  position: relative;

  height: 100%;
  width: 100%;
`

const Drawer = styled.aside<{ open: boolean }>`
  width: 350px;
  background-color: ${theme.colors.lightText};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    width: 270px;
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    z-index: 1000;
    transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
    box-shadow: none;
  }
`

const Backdrop = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 900;

  @media (min-width: 769px) {
    display: none;
  }
`

const HeaderButtons = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;

  z-index: 10;
  padding: 1rem 1.5rem;
  background: none;
  border: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`

const Main = styled.main`
  flex: 1;
  padding: 2rem;
  background-color: #f5f5f5;
  overflow-y: auto;
  height: 100%;
`

export default function DrawerLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const navigate = useNavigate()
  const [userInformation, setUserInformation] = useState<User | null>(null)
  const { context, isLoading: isLoadingAPI } = useAPI()

  useEffect(() => {
    if (bypassAuth) {
      return
    }

    const unsubscribe = onAuthStateChanged(auth, user => {
      if (!user) {
        console.log('Usuário não autenticado')
        return navigate('/')
      }
      setUserInformation(user)
    })

    return () => unsubscribe()
  }, [navigate])

  if ((!bypassAuth && !userInformation) || (bypassAuth && isLoadingAPI && !context.user)) {
    return <Loader />
  }

  return (
    <>
      <HeaderButtons>
        <ButtonVariants
          onClick={() => navigate(-1)}
          icon={faChevronLeft}
          size='lg'
          variant='light'
        />
        <ButtonVariants
          onClick={() => !drawerOpen && setDrawerOpen(true)}
          icon={faBars}
          size='lg'
          variant='light'
        />
      </HeaderButtons>
      <Layout>
        <Drawer open={drawerOpen}>
          <ManagementSidebar onNavigate={() => setDrawerOpen(false)} />
        </Drawer>
        {drawerOpen && <Backdrop open={drawerOpen} onClick={() => setDrawerOpen(false)} />}
        <Main onClick={() => drawerOpen && setDrawerOpen(false)}>
          <Outlet />
        </Main>
      </Layout>
    </>
  )
}
